export default __webpack_public_path__ + "static/media/IconError.4bd81cd1.svg";